import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-muted" }, "加载中...", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("草稿")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("上线")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看游戏记录")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "碰数分布", -1)
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("返回列表")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_icon, {
            class: "is-loading",
            size: 30
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Loading)
            ]),
            _: 1
          }),
          _hoisted_3
        ]))
      : (_ctx.pool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_descriptions, {
              title: "池子信息",
              column: 4,
              border: "",
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "池子名称" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pool.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "价格" }, {
                  default: _withCtx(() => [
                    (_ctx.pool.box_type === 'cash')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(Number(_ctx.pool.price).toFixed(2)) + "元", 1))
                      : (_ctx.pool.box_type === 'membership_point')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.pool.price) + "积分", 1))
                        : (_ctx.pool.box_type === 'extra_point')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.pool.price) + "军粮", 1))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "状态" }, {
                  default: _withCtx(() => [
                    (_ctx.pool.status === 'draft')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "info",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : (_ctx.pool.status === 'active')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "success",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : (_ctx.pool.status === 'archived')
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 2,
                              type: "danger",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pool.created_at), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "总游戏局数",
                          value: _ctx.stats.total_games || 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "总收入",
                          value: _ctx.totalRevenueYuan,
                          suffix: "元"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "总成本",
                          value: _ctx.totalCostYuan,
                          suffix: "元"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "总利润",
                          value: _ctx.profitYuan,
                          suffix: "元",
                          "value-style": { color: (_ctx.stats.actual_profit || 0) >= 0 ? '#67C23A' : '#F56C6C' }
                        }, null, 8, ["value", "value-style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "mb-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "利润率",
                          value: _ctx.profitRatePercent,
                          suffix: "%",
                          precision: 2,
                          "value-style": { color: (_ctx.stats.actual_profit_rate || 0) >= 0 ? '#67C23A' : '#F56C6C' }
                        }, null, 8, ["value", "value-style"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "赢家数",
                          value: _ctx.stats.user_gain_distribution?.winners_count || 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_statistic, {
                          title: "输家数",
                          value: _ctx.stats.user_gain_distribution?.losers_count || 0
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { shadow: "hover" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: { name: 'match_game_records', query: { match_pool_id: _ctx.poolId } }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              link: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.stats.match_count_distribution && _ctx.stats.match_count_distribution.length > 0)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  shadow: "hover",
                  class: "mb-4"
                }, {
                  header: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_table, {
                      data: _ctx.stats.match_count_distribution,
                      "row-config": { isHover: true }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_vxe_column, {
                          title: "碰数",
                          width: "80"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_tag, {
                              type: _ctx.getMatchCountTagType(row.match_count),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.match_count), 1)
                              ]),
                              _: 2
                            }, 1032, ["type"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_column, {
                          title: "次数",
                          width: "100"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(row.count), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_column, {
                          title: "占比",
                          width: "100"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createTextVNode(_toDisplayString(row.percentage.toFixed(2)) + "% ", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_column, {
                          title: "分布图",
                          "min-width": "300"
                        }, {
                          default: _withCtx(({ row }) => [
                            _createVNode(_component_el_progress, {
                              percentage: row.percentage,
                              color: _ctx.getProgressColor(row.percentage),
                              "show-text": false
                            }, null, 8, ["percentage", "color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "暂无统计数据"
                })),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 2,
            description: "池子不存在"
          }))
  ]))
}